module.exports = __webpack_public_path__ + "static/media/info.5b86a647.svg";